(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.itIt = mod.exports;
  }
})(this, function (exports) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    domain: '',
    menuToggle: {
      label: 'MENU'
    },
    logo: {
      href: '/'
    },
    mainBtn: [{
      text: 'CONTATTI',
      link: '/contatti'
    }, {
      text: 'REGISTRAZIONE',
      link: ''
    }],
    loginLink: {
      text: 'LOGIN',
      src: ''
    },
    siteLinks: [{
      title: {
        text: 'PRODOTTI'
      },
      list: [{
        text: 'Note Spese',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Gestione delle Note Spese',
          src: '/expense-management'
        }, {
          text: 'App Mobile',
          src: '/app-mobile-note-spese'
        }, {
          text: 'Gestione del Budget',
          src: '/budget-management'
        }, {
          text: 'Audit delle Spese',
          src: '/travel-expense-audit-service'
        }, {
          text: 'Gestione dei Rimborsi Chilometrici',
          src: '/concur-drive'
        }, {
          text: 'Ecosistema dei Partner',
          src: '/app-center'
        }]
      }, {
        text: 'Viaggi d’Affari',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Gestione dei Viaggi d’Affari',
          src: '/travel-booking'
        }, {
          text: 'App Mobile',
          src: '/app-mobile-note-spese'
        }, {
          text: 'Gestione del Budget',
          src: '/budget-management'
        }, {
          text: 'Ecosistema dei Partner',
          src: '/app-center'
        }]
      }, {
        text: 'Intelligent Enterprise',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Integrazioni',
          src: '/financial-connectors'
        }, {
          text: 'Analisi & Report',
          src: '/business-intelligence'
        }, {
          text: 'Gestione del Budget',
          src: '/budget-management'
        }]
      }, {
        text: 'Supporto',
        src: '',
        classes: 'sub-menu',
        subMenu: [{
          text: 'Supporto Amministrativo',
          src: '/service-administration'
        }, {
          text: 'Preferred Care',
          src: '/preferred-care'
        }]
      }, {
        text: 'Demo Expense',
        src: '/self-guided-demo-expense-it-it#/',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'SOLUZIONI'
      },
      list: [{
        text: 'Servizi Finanziari',
        src: '/servizi-finanziari'
      }, {
        text: 'Beni di Consumo',
        src: '/beni-di-consumo'
      }]
    }, {
      title: {
        text: 'CHI SIAMO'
      },
      list: [{
        text: 'Perché Concur',
        src: '/why-concur'
      }, {
        text: 'Mobile',
        src: '/mobile'
      }, {
        text: 'I nostri uffici',
        src: '/contact/offices'
      }, {
        text: 'Supporto',
        src: '/support'
      }, {
        text: 'Contatta un venditore',
        src: '/contatti',
        classes: 'call-out'
      }]
    }, {
      title: {
        text: 'RISORSE'
      },
      list: [{
        text: 'Resource Center',
        src: '/resource-center'
      }]
    }],
    supportLinks: [{
      text: 'BLOG ANGLAIS',
      href: ''
    }, {
      text: 'CONTATTI',
      href: '/contatti'
    }],
    mobileAppText: {
      text: 'GET CONCUR MOBILE APP'
    }
  };
});